import InvitationApi from '@/api/invitation'
import accountApi from '@/api/account'

const actions = {
  createInvitationsAction: async ({ getters, rootGetters }, payload) => {
    const extraParams = {}
    if (rootGetters['multipleSessions/canLimitInviteSent']) {
      extraParams.limitedAddInvitations = true
    }
    if (getters.canUseAntiPhishing) {
      extraParams.v = 2
    }
    if (rootGetters['featureToggles/canReplyToSender']) {
      extraParams.enableSenderReplyTo = true
    }
    return InvitationApi.createInvitations(payload, extraParams)
  },

  createAccountAction: async ({ getters }, payload) => {
    const extraParams = {}
    if (getters.canUseAntiPhishing) {
      extraParams.v = 2
    }
    return accountApi.createAccount(payload, extraParams)
  },
}

export default actions
